import { Route } from './util/route';
import { GamePOI, } from './model';
import { HttpVerb } from './util/http-verb.enum';
export const URLS = {
    LOCAL: 'https://urbanchallenger.ddev.site',
    DEV: 'https://stage.urbanchallenger.com',
    PROD: 'https://api.urbanchallenger.com',
};
export const Routes = {
    CLAIM_GAME: Route.make('game/claim', HttpVerb.POST_JSON),
    CLAIM_VOUCHER: Route.make('voucher/claim', HttpVerb.POST_JSON),
    CREATE_TEAMS: Route.make('game/teams', HttpVerb.POST_JSON),
    END_AND_ARCHIVE: Route.make('game/archive', HttpVerb.POST_JSON),
    JOIN_TEAM: Route.make((code) => `team/${code}/join`),
    LEAVE_TEAM: Route.make((code) => `team/${code}/leave`),
    ME: Route.make('me'),
    DELETE_ACCOUNT: Route.make('me/account', HttpVerb.DELETE),
    MODERATE: Route.make('moderate/status'),
    MOD_OVERVIEW: Route.make('moderate/overview'),
    MOD_GAME: Route.make((gameId) => `moderate/game/${gameId}`),
    MOD_ARCHIVE_GAME: Route.make((gameId) => `moderate/game/${gameId}`, HttpVerb.DELETE),
    MOD_CREATE_GAME: Route.make('game/create/manual/simple', HttpVerb.POST_FORM),
    MOD_CREATE_GAME_V7: Route.make('moderate/game/create/manual/simple', HttpVerb.POST_FORM),
    MOD_CREATE_GAME_ADVANCED: Route.make('game/create/manual', HttpVerb.POST_FORM),
    MOD_CREATE_GAME_ADVANCED_V7: Route.make('moderate/game/create/manual', HttpVerb.POST_FORM),
    MOD_GAME_DECLARE_RESULTS: Route.make((gameId) => `moderate/game/${gameId}/results`, HttpVerb.POST_JSON),
    MOD_GAME_UNDO_DECLARE_RESULTS: Route.make((gameId) => `moderate/game/${gameId}/results`, HttpVerb.DELETE),
    MOD_GAME_ADD_TEAM: Route.make((gameId) => `moderate/game/${gameId}/team`, HttpVerb.POST_JSON),
    MOD_GAME_EDIT: Route.make((gameId) => `moderate/game/${gameId}`, HttpVerb.PATCH),
    MOD_TASK_APPROVE: Route.make((id) => `moderate/${id}/approve`, HttpVerb.PATCH),
    MOD_TASK_APPROVE_V7: Route.make((id) => `moderate/task/${id}/approve`, HttpVerb.PATCH),
    MOD_TASK_REJECT: Route.make((id) => `moderate/${id}/reject`, HttpVerb.PATCH),
    MOD_TASK_REJECT_V7: Route.make((id) => `moderate/task/${id}/reject`, HttpVerb.PATCH),
    MOD_GET_PLANS: Route.make('moderate/plans'),
    MOD_GAME_POI_ADD: Route.make((gameId) => `moderate/game/${gameId}/poi`, HttpVerb.POST_JSON),
    MOD_GAME_POI_EDIT: Route.make((gameId, poiId) => `moderate/game/${gameId}/poi/${poiId}`, HttpVerb.PATCH),
    MOD_GAME_POI_DELETE: Route.make((gameId, poiId) => `moderate/game/${gameId}/poi/${poiId}`, HttpVerb.DELETE),
    DEPRECATED_START_GAME: Route.make('team/start', HttpVerb.POST_JSON),
    START_GAME: Route.make('team/start', HttpVerb.POST_JSON),
    UPDATE_TEAM_NAME: Route.make('team/name', HttpVerb.POST_JSON),
    START_DEMO: Route.make('demo/start'),
    STOP_GAME: Route.make('team/stop'),
    TASK_MARK_COMPLETED: Route.make('task', HttpVerb.POST_FORM),
    TeamPhotoUpload: Route.make((code) => `team/${code}/photo/upload`, HttpVerb.POST_FORM),
    TeamPhotoSelection: Route.make((code) => `team/${code}/photo/selection`),
    GetChallenges: Route.make((gameSlug) => `challenges/${gameSlug}`),
    // Admin-only routes -------------------------------------------------------
    // Game variants
    VariantsList: Route.make('admin/variants'),
    VariantCreate: Route.make('admin/variants', HttpVerb.POST_JSON),
    VariantUpdate: Route.make((variantId) => `admin/variants/${variantId.toString(10)}`, HttpVerb.PATCH),
    VariantDelete: Route.make((variantId) => `admin/variants/${variantId.toString(10)}`, HttpVerb.DELETE),
    // Users with special roles
    UserRoleList: Route.make('admin/users'),
    UserRoleCreate: Route.make('admin/users', HttpVerb.POST_JSON),
    UserRoleUpdate: Route.make((mappingId) => `admin/users/${mappingId.toString(10)}`, HttpVerb.PUT),
    UserRoleDelete: Route.make((mappingId) => `admin/users/${mappingId.toString(10)}`, HttpVerb.DELETE),
    // User generated challenges
    UserChallenges: Route.make('admin/userchallenges'),
    // Scoreboard
    Scoreboard: Route.make('admin/scoreboard'),
    // Unmoderated games
    UnmoderatedGames: Route.make('admin/unmoderated-games'),
    // Archived (moderated) games
    ArchivedGames: Route.make('admin/archived-games'),
    // Webflow challenge sync
    WebflowSyncStart: Route.make('admin/webflow-sync', HttpVerb.POST_JSON),
    WebflowSyncStatus: Route.make('admin/webflow-sync/status'),
};
//# sourceMappingURL=config.js.map